import Person from '@mui/icons-material/Person';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function PersonIcon(props: FixMe) {
  return <Person {...props} />;
}

export default PersonIcon;
